import React, { useState } from "react";
import { FaPlay, FaImages } from "react-icons/fa";

const EventTime = () => {
  const [showModal, setShowModal] = useState(false);
  const [showEnquiryModal, setShowEnquiryModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
const [formData, setFormData] = useState({
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  message: ""
});

  // Sample images for the screenshot gallery
  const screenshotImages = [
    "/images/eventime/Live1.png",
    "/images/eventime/Live2.png",
    "/images/eventime/Live3.png",
    "/images/eventime/Live4.png",
    "/images/eventime/Live5.png",
    "/images/eventime/Live6.png"
  ];

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === screenshotImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? screenshotImages.length - 1 : prevIndex - 1
    );
  };

const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData({
    ...formData,
    [name]: value
  });
};

const handleSubmit = async (e) => {
  e.preventDefault();
  
  try {
    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      phonenumber: formData.phone,
      email: formData.email,
      message: formData.message,
      type: "contact"
    };

    const response = await fetch("https://tnreaders.in/web/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      console.log("Form submitted successfully");
      // Reset form and close modal
      setFormData({ 
        firstName: "", 
        lastName: "", 
        phone: "", 
        email: "", 
        message: "" 
      });
      setShowEnquiryModal(false);
      alert("Thank you for your enquiry! We'll contact you soon.");
    } else {
      throw new Error("Failed to submit form");
    }
  } catch (error) {
    console.error("Error submitting form:", error);
    alert("There was an error submitting your form. Please try again.");
  }
};
  return (
    <div className="eventmie-product">
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-modal" onClick={() => setShowModal(false)}>
              &times;
            </button>
            <div className="image-container">
              <img
                src={screenshotImages[currentImageIndex]}
                alt={`Screenshot ${currentImageIndex + 1}`}
              />
            </div>
            <div className="modal-navigation">
              <button className="nav-arrow" onClick={handlePrevImage}>
                &larr; Previous
              </button>
              <span className="image-counter">
                {currentImageIndex + 1} / {screenshotImages.length}
              </span>
              <button className="nav-arrow" onClick={handleNextImage}>
                Next &rarr;
              </button>
            </div>
          </div>
        </div>
      )}
{showEnquiryModal && (
  <div className="modal-overlay">
    <div className="modal-content enquiry-form">
      <button
        className="close-modal"
        onClick={() => setShowEnquiryModal(false)}
      >
        &times;
      </button>
      <h2>Request Demo</h2>
      <p>Please fill out this form to request a demo of our product.</p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="firstName">First Name:</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="lastName">Last Name:</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone:</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>

        <button type="submit" className="submit-btn">
          Submit Request
        </button>
      </form>
    </div>
  </div>
)}
      <div className="product-container">
        {/* Product Description Section */}
        <section className="product-description">
          <div className="section-header">
            <span className="section-badge">EVENT MANAGEMENT</span>
            <h1>Event-Management</h1>
            <h2>Complete Event Booking and Management System</h2>
          </div>
          <div className="description-content">
            <p>
              Event-Management is a powerful Laravel-based event management system
              that enables organizers to create, manage, and sell tickets for
              all types of events. From conferences to concerts, it provides all
              the tools needed to run successful events.
            </p>
            <div className="highlight-box">
              <p>
                <strong>Key Benefit:</strong> All-in-one solution combining
                event creation, ticket sales, attendee management, and
                promotional tools with beautiful, customizable interfaces.
              </p>
            </div>
          </div>
        </section>

        <div className="btnalignmnt">
          <button
            className="livepreview"
            onClick={() => setShowEnquiryModal(true)}
          >
            <FaPlay style={{ marginRight: "8px" }} />
            Demo
          </button>
          <button className="screenshot" onClick={() => setShowModal(true)}>
            <FaImages style={{ marginRight: "8px" }} />
            Screenshots
          </button>
        </div>

        {/* Product Features Section */}
        <section className="product-features">
          <div className="section-header">
            <span className="section-badge">FEATURES</span>
            <h2>Event Management Capabilities</h2>
          </div>
          <div className="features-grid">
            {[
              {
                icon: "🎤",
                title: "Event Creation",
                description:
                  "Create events with detailed information, schedules, and speakers"
              },
              {
                icon: "🎟️",
                title: "Ticket Management",
                description:
                  "Multiple ticket types with pricing tiers and capacity limits"
              },
              {
                icon: "💳",
                title: "Payment Gateways",
                description:
                  "Stripe, PayPal, Razorpay, and offline payment options"
              },
              {
                icon: "📊",
                title: "Attendee Management",
                description: "Track registrations, check-ins, and attendee data"
              },
              {
                icon: "📱",
                title: "Mobile Responsive",
                description: "Fully responsive design works on all devices"
              },
              {
                icon: "📈",
                title: "Analytics Dashboard",
                description: "Track sales, attendance, and revenue in real-time"
              }
            ].map((feature, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Technology Used Section */}
        <section className="technology-used">
          <div className="section-header">
            <span className="section-badge">TECHNOLOGY</span>
            <h2>Modern Event Technology Stack</h2>
          </div>
          <div className="tech-stack">
            <div className="tech-category">
              <div className="tech-header">
                <div className="tech-icon">💻</div>
                <h3>Frontend</h3>
              </div>
              <ul>
                <li>HTML5, CSS3, JavaScript (ES6+)</li>
                <li>Bootstrap 4 responsive framework</li>
                <li>jQuery for interactive components</li>
                <li>Vue.js for dynamic interfaces</li>
              </ul>
            </div>

            <div className="tech-category">
              <div className="tech-header">
                <div className="tech-icon">🔌</div>
                <h3>Backend</h3>
              </div>
              <ul>
                <li>PHP 7.3+ (Laravel 6.x framework)</li>
                <li>MySQL relational database</li>
                <li>RESTful API architecture</li>
                <li>Redis for caching</li>
              </ul>
            </div>

            <div className="tech-category">
              <div className="tech-header">
                <div className="tech-icon">🛠️</div>
                <h3>Integrations</h3>
              </div>
              <ul>
                <li>Stripe, PayPal, Razorpay</li>
                <li>Google Maps for venue locations</li>
                <li>Mailchimp for email marketing</li>
                <li>Social media sharing</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Event Types Section */}
        <section className="event-types">
          <div className="section-header">
            <span className="section-badge">EVENTS</span>
            <h2>Supported Event Types</h2>
          </div>
          <div className="types-grid">
            {[
              { icon: "🎤", type: "Conferences", count: "Business, Tech" },
              { icon: "🎵", type: "Concerts", count: "Music, Performances" },
              { icon: "🎭", type: "Workshops", count: "Educational, Training" },
              { icon: "🏟️", type: "Sports", count: "Games, Tournaments" },
              { icon: "🎨", type: "Exhibitions", count: "Art, Trade Shows" },
              { icon: "🍽️", type: "Food Events", count: "Festivals, Tastings" }
            ].map((event, index) => (
              <div className="type-item" key={index}>
                <div className="type-icon">{event.icon}</div>
                <h3>{event.type}</h3>
                <p>{event.count}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Organizer Tools Section */}
        <section className="organizer-tools">
          <div className="section-header">
            <span className="section-badge">ORGANIZER</span>
            <h2>Event Management Tools</h2>
          </div>
          <div className="tools-grid1">
            <div className="tool-card">
              <div className="tool-icon">📅</div>
              <h3>Event Calendar</h3>
              <p>Manage multiple events with visual calendar</p>
            </div>
            <div className="tool-card">
              <div className="tool-icon">📝</div>
              <h3>Custom Forms</h3>
              <p>Collect attendee information during registration</p>
            </div>
            <div className="tool-card">
              <div className="tool-icon">📧</div>
              <h3>Email Notifications</h3>
              <p>Automated emails for tickets, reminders</p>
            </div>
            <div className="tool-card">
              <div className="tool-icon">📊</div>
              <h3>Reporting</h3>
              <p>Generate sales and attendance reports</p>
            </div>
          </div>
        </section>

        {/* Ticketing Features Section */}
        <section className="ticketing-features">
          <div className="section-header">
            <span className="section-badge">TICKETING</span>
            <h2>Advanced Ticketing System</h2>
          </div>
          <div className="features-list">
            <div className="feature-column">
              <ul>
                <li>🎫 Multiple ticket types</li>
                <li>💰 Discount codes</li>
                <li>📅 Early bird pricing</li>
              </ul>
            </div>
            <div className="feature-column">
              <ul>
                <li>👥 Group bookings</li>
                <li>🔄 Refund processing</li>
                <li>📱 Mobile tickets</li>
              </ul>
            </div>
            <div className="feature-column">
              <ul>
                <li>🔢 Capacity management</li>
                <li>⏱️ Time-limited offers</li>
                <li>📈 Sales analytics</li>
              </ul>
            </div>
          </div>
        </section>
      </div>

      {/* CSS Styles with Event Management Theme */}
      <style>{`
        :root {
          --primary-color: rgb(14,89,145);
          --secondary-color: #137eb1;
          --light-accent: #f3e5f5;
          --dark-shade: #4a148c;
          --text-color: #2d3748;
          --light-text: #f8fafc;
        }
        
        .eventmie-product {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          line-height: 1.6;
          color: var(--text-color);
          margin: 0 auto;
          padding: 0rem;
          background: linear-gradient(135deg, #fdfcff 0%, #f5f0ff 100%);
        }
        
                       .btnalignmnt{
          display: flex;
    justify-content: center;
    margin-bottom: 20px;
    gap: 10px;
    flex-wrap: wrap;
        }

.livepreview,
.screenshot {
  border: none;
  background: white;
  box-shadow: 0 5px 15px rgba(124, 1, 177, 0.05);
  border: 1px solid rgba(124, 1, 177, 0.1);
  padding: 10px 20px;
  border-radius: 10px;
  color: var(--primary-color);
  cursor: pointer;
  transition: all 0.3s ease;
}

.livepreview:hover,
.screenshot:hover {
  background-color: var(--primary-color);
  color: white;
  transform: scale(1.05);
  box-shadow: 0 8px 20px rgba(124, 1, 177, 0.15);
}

        
        .navigation-buttons {
          position: fixed;
          top: 20px;
          right: 20px;
          display: flex;
          gap: 10px;
          z-index: 1000;
        }

        .admin-features{
            padding-top: 20px
        }
        
        .nav-button {
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          border: none;
          transition: all 0.3s ease;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        }

                /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1001;
        }
        
        .modal-content {
          background: white;
          padding: 2rem;
          border-radius: 10px;
          max-width: 80%;
          height: auto;
          position: relative;
          box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
        }
        
        .close-modal {
          position: absolute;
          top: 15px;
          right: 15px;
          background: none;
          border: none;
          font-size: 1.5rem;
          cursor: pointer;
          color: var(--text-color);
        }
        
        .image-container {
          margin: 1rem 0;
          text-align: center;
        }
        
        .image-container img {
          max-width: 100%;
          max-height: 500px;
          border-radius: 5px;
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
        }
        
        .modal-navigation {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 1rem;
        }
        
        .nav-arrow {
          background: var(--primary-color);
          color: white;
          border: none;
          padding: 0.5rem 1rem;
          border-radius: 5px;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .nav-arrow:hover {
          background: var(--dark-shade);
        }
        
        .image-counter {
          font-weight: 600;
        }
        
        .farmart-product {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          line-height: 1.6;
          color: var(--text-color);
          margin: 0 auto;
          padding: 0rem;
        }
        
        .product-container {
          background: white;
          border-radius: 16px;
          box-shadow: 0 10px 30px rgba(124, 1, 177, 0.1);
          padding: 2rem;
          overflow: hidden;
        }

        .product-description{
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        }

        
        .section-header {
          margin-bottom: 2rem;
          position: relative;
        }
        
        .section-badge {
          display: inline-block;
          background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
          color: white;
          padding: 0.35rem 1rem;
          border-radius: 50px;
          font-size: 0.75rem;
          font-weight: 600;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          margin-bottom: 1rem;
        }
        
        h1 {
          color: var(--primary-color);
          font-size: 2.5rem;
          font-weight: 700;
          line-height: 1.2;
          margin-bottom: 0.5rem;
        }
        
        h2 {
          color: var(--dark-shade);
          font-size: 1.75rem;
          font-weight: 600;
          margin-bottom: 1.5rem;
          position: relative;
        }
        
        h3 {
          color: var(--primary-color);
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 0.75rem;
        }
        
        p {
          margin-bottom: 1rem;
          color: var(--text-color);
          font-size: 1rem;
          line-height: 1.7;
        }
        
        .description-content {
          max-width: 800px;
        }
        
        .highlight-box {
          background: var(--light-accent);
          border-left: 4px solid var(--secondary-color);
          padding: 1.25rem;
          border-radius: 0 8px 8px 0;
          margin: 1.5rem 0;
        }
        
        .highlight-box p {
          margin: 0;
          color: var(--dark-shade);
        }
        
        .features-grid, .types-grid, .tools-grid1 {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin-bottom: 2rem;
    gap: 20px;
        }
        
        .feature-card, .type-item {
          background: white;
          padding: 1.5rem;
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(124, 1, 177, 0.05);
          border: 1px solid rgba(124, 1, 177, 0.1);
          transition: all 0.3s ease;
          text-align: center;
        }

        .tool-card{
            background: white;
    padding: 1.5rem;
    border-radius: 10px;
    box-shadow: 0 5px 15px rgba(124, 1, 177, 0.05);
    border: 1px solid rgba(124, 1, 177, 0.1);
    transition: all 0.3s ease;
    text-align: center;
    display: flex
;
    flex-direction: column;
    width: 20%;
    height: auto
        }
        
        .feature-card:hover, .type-item:hover, .tool-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(124, 1, 177, 0.15);
          border-color: rgba(124, 1, 177, 0.2);
        }
        
        .feature-icon, .type-icon, .tool-icon {
          font-size: 2rem;
          margin-bottom: 1rem;
          color: var(--secondary-color);
        }
        
        .tech-stack {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-evenly;
            align-items: center;
            margin-bottom: 2rem;
        }

                .technology-used{
          padding-top: 20px;
        }
        
        .tech-category {
          background: white;
          padding: 1.5rem;
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(124, 1, 177, 0.05);
          border: 1px solid rgba(124, 1, 177, 0.1);
        }
        
        .tech-header {
          display: flex;
          align-items: center;
          margin-bottom: 1rem;
        }
        
        .tech-icon {
          font-size: 1.5rem;
          margin-right: 0.75rem;
          color: var(--secondary-color);
        }
        
        .features-list {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-evenly;
            align-items: center;
            margin-bottom: 2rem;
        }
        
        .feature-column ul {
          padding-left: 0;
        }
        
        .feature-column li {
          margin-bottom: 1rem;
          position: relative;
          list-style-type: none;
          padding-left: 2rem;
          font-size: 1rem;
        }
        
        .feature-column li::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          font-size: 1.2rem;
        }

                                                .enquiry-form {
  max-width: 500px;
  padding: 30px;
  background: white;
  border-radius: 8px;
}

.enquiry-form h2 {
  margin-top: 0;
  color: #2c3e50;
}

.enquiry-form p {
  margin-bottom: 20px;
  color: #7f8c8d;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
  text-align: left;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.submit-btn {
  background-color: rgb(14,89,145);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  transition: background-color 0.3s;
}

.submit-btn:hover {
  background-color: #137eb1;
}
        
        @media (max-width: 768px) {
          .product-container {
            padding: 1rem;
          }
          
          h1 {
            font-size: 2rem;
          }
          
          h2 {
            font-size: 1.5rem;
          }
          
          .features-grid, .tech-stack, .types-grid, .tools-grid1, .features-list {
            display: flex;
            flex-direction: column;
          }
            .type-item{
            width: 100%;}
            .tool-card {
    background: white;
    padding: 1.5rem;
    border-radius: 10px;
    box-shadow: 0 5px 15px rgba(124, 1, 177, 0.05);
    border: 1px solid rgba(124, 1, 177, 0.1);
    transition: all 0.3s ease;
    text-align: center;
    display: flex
;
    flex-direction: column;
    width: 100%;
    height: auto;
}

                                            .btnalignmnt{
          display: flex;
    justify-content: center;
    margin-bottom: 20px;
    gap: 10px;
        }
        }
      `}</style>
    </div>
  );
};

export default EventTime;
